import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import State from 'store/State';
import { OrderIdsStreamRequest } from 'communication/types/order/OrderIdsStreamRequest';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';

export function createOrderIdsStreamRequest(
    orderIds: string[],
    _portfolioSelection: PortfolioSelectionWrapper,
    _widgetKey: string,
    _appSettings: AppSettingsState,
    _state: State
): OrderIdsStreamRequest | undefined {
    return toOrderIdsStreamRequest(orderIds);
}

export function toOrderIdsStreamRequest(
    orderIds: string[]
): OrderIdsStreamRequest | undefined {
    return {
        orderIds: orderIds.join(),
    };
}
